import { render, staticRenderFns } from "./SfSelect.vue?vue&type=template&id=0c2c1eed&"
import script from "./SfSelect.vue?vue&type=script&lang=js&"
export * from "./SfSelect.vue?vue&type=script&lang=js&"
import style0 from "./SfSelect.vue?vue&type=style&index=0&id=0c2c1eed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports